export const CAMERA_Z_DISTANCE_FROM_PLAYER = 40;
